import { ReactNode, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useAuth } from "./AuthContext";

interface AdminGuardProps {
    children: ReactNode;
    silent?: boolean;
}

export const AdminGuard = ({ children, silent = false }: AdminGuardProps) => {
    const { user, loading } = useAuth();
    const navigate = useNavigate();
    const isAdmin = user?.admin || user?.info?.admin;

    useEffect(() => {
        if (loading || isAdmin || silent) return;
        toast.warn("Admin privileges required.", { autoClose: 5000 });
        navigate("/", { replace: true });
    }, [loading, isAdmin, silent, navigate]);

    if (loading) {
        return null;
    }

    if (isAdmin) {
        return <>{children}</>;
    }

    if (silent) {
        return null;
    }

    return null;
};